import useTranslation from 'hooks/useTranslation';

const VideoMessage = ({
  id,
  url,
  time,
  replyId,
  getMessagePreviewById,
  name,
}) => {
  const { getTranslation } = useTranslation('COMMON');
  const { t } = getTranslation();

  //   const handleShowRepliedMessage = () => {
  //     handleScrollIntoView(replyId);
  //   };

  return (
    <div
      data-id={id}
      className='conv__body__body__inner__msgleft__inner__bubble__video '
    >
      {replyId && (
        <div
          dir='auto'
          className='conv__body__body__inner__msgright__inner__bubble__replied_msg'
          // onClick={handleShowRepliedMessage}
        >
          <span>
            <span>{getMessagePreviewById(replyId)}</span>
          </span>
        </div>
      )}
      <video width='500' controls preload='none'>
        <source src={url} type='video/mp4' />
        <source src={url} type='video/ogg' />
        {t('BROWSER_NOT_SUPPORTING_VIDEO_FILE')}
      </video>
      <div className='conv__body__body__inner__msgleft__inner__bubble__video__info flex flex-ai-c flex-jc-c'>
        <div className='conv__body__body__inner__msgleft__inner__bubble__video__info__time'>
          {time} {'  '} {name}
        </div>
      </div>
    </div>
  );
};

export default VideoMessage;
